import React, { Fragment } from 'react';

import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconLoading } from 'images/connection/connecting-white.svg';
import { ReactComponent as IconX } from 'images/general/x.svg';

import './Connecting.scss'

function Connecting(props) {
    const s = useLocalizedStrings();

    return (
        <div className="register-home-connecting">
            <IconLoading className="icon" />
            <div className="label">{s.connectToGateway}</div>
            <div />
            <div onClick={props.clearPhoneNumber} className="try">{s.tryAnotherHub}</div>
        </div>
    )
}

export function NewHomeProcessLoading({ clearPhoneNumber, loadingText, canDismiss, dismiss }) {
    const s = useLocalizedStrings();

    return (
        <div className="register-home-connecting">
           {
                canDismiss ? <Fragment>
                    <IconX className="x-icon" />
                    <div className="x-button" onClick={dismiss} />
                </Fragment> : null
            }

            <IconLoading className="icon" />
            <div className="label">{loadingText}</div>
            <div />
            {(clearPhoneNumber !== undefined) ?
                <div onClick={clearPhoneNumber} className="try">{s.tryAnotherPhoneNumber}</div>
                : null}
        </div>
    )
}

export default Connecting;